module.exports = __webpack_public_path__ + "img/download.84c37616.svg";